import styled from "styled-components";

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  border-radius: 10px;
  border: 1px solid var(--primary-dark-100);
  background: #fff;
  padding: 30px;
  position: relative;
  width: 160px;
  height: 185px;
  flex-shrink: 0;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover {
    transform: scale(1.05);
  }

  @media (min-width: 2560px) {
    width: 170px;
    height: 220px;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  max-width: min-content;
`;

export const CardTitle = styled.span`
  color: var(--primary-blue-300);
  text-align: center;
  font-size: var(--fs-sm);
  font-weight: 400;
  line-height: normal;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const CardValue = styled.div`
  font-size: var(--fs-xlg);
  font-weight: 600;
`;

export const CardFooter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;

  background: rgba(239, 241, 252, 0.5);
`;

export const CardDescription = styled.p`
  color: var(--primary-blue);
  font-size: var(--fs-base);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
